module.exports = __webpack_public_path__ + "src/assets/img/share/tips/extroversion/07c13ea6508ea11c1a42c4f417bfbb5b.png";